(function () {
  "use strict";

  var DEMO_LIMITS = {
    customTasks: 3,
    customBrainDumps: 2,
    customHabits: 1,
    customSelfCare: 1,
    customBills: 1,
    dailyDates: 1,
  };

  /* Structured Space Demo Framework — central metadata (Prompt 00 / 11) */
  var DEMO_FRAMEWORK = {
    isDemo: true,
    productName: "ADHD Life Planner",
    productSlug: "adhd-life-planner",
    demoVersion: "2.0.0",
    schemaVersion: 2,
    storageNamespace: "structuredSpace_adhd-life-planner_demo_v1",
    purchaseLabelDefault: "Get the full ADHD Life Planner",
    resetLabelDefault: "Reset Demo",
    bannerCopy:
      "You\u2019re exploring the ADHD Life Planner demo. Try the features, add or edit items, and reset the sample whenever you like.",
  };

  var STORAGE_KEY = DEMO_FRAMEWORK.storageNamespace;
  var LEGACY_STORAGE_KEYS = ["structuredSpace.adhdPlanner.interactiveDemo.v1"];
  var LEGACY_WELCOME_KEY = "structuredSpace.adhdPlanner.interactiveDemo.welcome.v1";

  var TOUR_STEPS = [
    {
      page: "home",
      title: "Your calm command centre",
      body: "The dashboard rolls up tasks, habits and money in one gentle view \u2014 the same layout as the full planner.",
    },
    {
      page: "today",
      title: "Focus on today",
      body: "Set one focus line and top priorities. Edits save inside this demo only.",
    },
    {
      page: "tasks",
      title: "Capture and complete tasks",
      body: "Add a task, tick one off, or edit sample items. The full planner keeps unlimited history.",
    },
    {
      page: "habits",
      title: "Track habits this week",
      body: "Tick the weekly grid to see streaks update. Past weeks unlock in the full planner.",
    },
    {
      page: "home",
      title: "Calm mode for low-energy days",
      body: "Turn on Calm mode from the top bar to hide noise and show just the essentials.",
      action: "calm-hint",
    },
    {
      page: "start",
      title: "Explore locked sections safely",
      body: "Pages marked Full version are previews. They show what unlocks without breaking the demo.",
    },
    {
      page: "home",
      title: "Ready when you are",
      body: "Reset Demo restores sample data any time. Get the full ADHD Life Planner to keep your own plan.",
      finish: true,
    },
  ];
  var PAGE_META = {
    home: { eyebrow: "Command", title: "Home Dashboard", sub: "Live rollups from your demo entries." },
    today: { eyebrow: "Do", title: "Today", sub: "A calm view of right now — same layout as the complete planner." },
    daily: { eyebrow: "Do", title: "Daily Plan", sub: "Plan today with the same field layout as the complete planner." },
    weekly: { eyebrow: "Do", title: "Weekly Plan", sub: "Preview of the full weekly planner — unlocks in the complete version." },
    tasks: { eyebrow: "Do", title: "Task Hub", sub: "Add, complete and organise tasks — with full-version extras shown locked." },
    brain: { eyebrow: "Do", title: "Brain Dump", sub: "Empty your head — sort later." },
    habits: { eyebrow: "Track", title: "Habits & Routines", sub: "Tick this week’s habits — week history unlocks fully in the complete planner." },
    selfcare: { eyebrow: "Track", title: "Self-Care", sub: "Small acts of care count." },
    energy: { eyebrow: "Track", title: "Energy / Mood", sub: "Preview of check-ins — editable tracking unlocks in the complete planner." },
    appointments: { eyebrow: "Track", title: "Appointments", sub: "Preview of upcoming dates — full management unlocks in the complete planner." },
    goals: { eyebrow: "Track", title: "Goals", sub: "Preview of goals and steps — unlocks in the complete planner." },
    documents: { eyebrow: "Track", title: "Documents", sub: "Preview of reference notes — unlocks in the complete planner." },
    budget: { eyebrow: "Track", title: "Budget & Bills", sub: "Simplified money preview with the full layout shown." },
    "weekly-reset": { eyebrow: "Review", title: "Weekly Reset", sub: "Preview of a gentle weekly review — unlocks in the complete planner." },
    "monthly-reset": { eyebrow: "Review", title: "Monthly Reset", sub: "Preview of a monthly reset — unlocks in the complete planner." },
    start: { eyebrow: "Reference", title: "Start Here", sub: "How this interactive demo works." },
    settings: { eyebrow: "Reference", title: "Demo Settings", sub: "Palette, calm mode and temporary storage options." },
    "settings-backup": { eyebrow: "Reference", title: "Complete Settings & Backup", sub: "Preview of backup and sync tools — unlocks in the complete planner." },
  };

  var PALETTES = [
    { id: "pastel", label: "Pastel", color: "#7C6BB0" },
    { id: "classic", label: "Classic", color: "#5E6E55" },
    { id: "nature", label: "Nature", color: "#3F6F63" },
    { id: "cozy", label: "Cozy", color: "#B7791F" },
    { id: "space", label: "Space", color: "#6E8499" },
  ];

  function uid() {
    return "v-" + Math.random().toString(36).slice(2, 9) + Date.now().toString(36);
  }

  function todayKey() {
    var d = new Date();
    return d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0") + "-" + String(d.getDate()).padStart(2, "0");
  }

  function dateKeyFromDate(d) {
    return d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0") + "-" + String(d.getDate()).padStart(2, "0");
  }

  function habitStreak(habit, days) {
    if (!habit || !habit.logs) return 0;

    /* Current streak ending today (skips today if not yet ticked) */
    var d = new Date();
    d.setHours(12, 0, 0, 0);
    if (!habit.logs[todayKey()]) {
      d.setDate(d.getDate() - 1);
    }
    var live = 0;
    for (var i = 0; i < 366; i++) {
      var key = dateKeyFromDate(d);
      if (habit.logs[key]) {
        live += 1;
        d.setDate(d.getDate() - 1);
      } else {
        break;
      }
    }

    /* Best consecutive run inside the visible week (demo weeks are short) */
    var weekBest = 0;
    var run = 0;
    (days || []).forEach(function (day) {
      if (habit.logs[day]) {
        run += 1;
        if (run > weekBest) weekBest = run;
      } else {
        run = 0;
      }
    });

    return Math.max(live, weekBest);
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function clampText(value, max) {
    return String(value || "").trim().slice(0, max || 120);
  }

  function parseMoney(value) {
    var n = Number(String(value).replace(/[^0-9.]/g, ""));
    if (!isFinite(n) || n < 0) return 0;
    return Math.round(n * 100) / 100;
  }

  function weekDates(weekStartsOn) {
    var start = Number(weekStartsOn) || 1;
    var now = new Date();
    var day = now.getDay();
    var diff = (day - start + 7) % 7;
    var mondayish = new Date(now);
    mondayish.setHours(0, 0, 0, 0);
    mondayish.setDate(now.getDate() - diff);
    var out = [];
    for (var i = 0; i < 7; i++) {
      var d = new Date(mondayish);
      d.setDate(mondayish.getDate() + i);
      out.push(d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0") + "-" + String(d.getDate()).padStart(2, "0"));
    }
    return out;
  }

  function dayLabel(iso, locale) {
    var d = new Date(iso + "T12:00:00");
    return d.toLocaleDateString(locale || "en-GB", { weekday: "short" });
  }

  function createDemoState() {
    var days = weekDates(1);
    var habitDefs = [
      "Take medication",
      "Drink water",
      "Ten-minute tidy",
      "Go outside",
      "Start wind-down routine",
    ];
    var patterns = [
      [1, 1, 1, 1, 1, 0, 1],
      [1, 1, 0, 1, 1, 1, 0],
      [0, 1, 1, 0, 1, 0, 1],
      [1, 0, 1, 1, 0, 1, 1],
      [1, 1, 1, 0, 1, 1, 0],
    ];
    var habits = habitDefs.map(function (name, idx) {
      var logs = {};
      days.forEach(function (day, i) {
        logs[day] = !!patterns[idx][i];
      });
      return { id: "sample-habit-" + idx, name: name, logs: logs, isDemoSample: true };
    });

    return {
      version: 1,
      schemaVersion: DEMO_FRAMEWORK.schemaVersion,
      currentPage: "home",
      welcomeDismissed: false,
      tourCompleted: false,
      settings: {
        userName: "Maya",
        palette: "pastel",
        calmMode: false,
        darkMode: false,
        dateFormat: "en-GB",
        weekStartsOn: 1,
      },
      today: {
        focus: "Finish the council tax form",
        priorities: ["Reply to the school email", "Book the dentist appointment", "Order repeat prescription"],
        notes: "Keep tonight light — no new admin after 7pm.",
      },
      daily: {
        brainDump: "Check when the car insurance renews\nLook for the warranty email",
        taskLines: ["Submit council tax form", "Reply to school email", "Buy groceries", ""],
        selfCareNotes: "Sit outside with a cup of tea\nHave an early night",
      },
      tasks: [
        { id: "t1", title: "Submit council tax form", done: false, isDemoSample: true },
        { id: "t2", title: "Reply to school email", done: false, isDemoSample: true },
        { id: "t3", title: "Order repeat prescription", done: true, isDemoSample: true },
        { id: "t4", title: "Buy groceries", done: false, isDemoSample: true },
        { id: "t5", title: "Call the dentist", done: false, isDemoSample: true },
        { id: "t6", title: "Put clean bedding on", done: true, isDemoSample: true },
      ],
      brainDumps: [
        { id: "b1", text: "Check when the car insurance renews", isDemoSample: true },
        { id: "b2", text: "Look for the warranty email", isDemoSample: true },
        { id: "b3", text: "Birthday ideas for Mum", isDemoSample: true },
        { id: "b4", text: "Ask the GP about the referral", isDemoSample: true },
      ],
      habits: habits,
      selfCare: [
        { id: "s1", text: "Sit outside with a cup of tea", done: false, isDemoSample: true },
        { id: "s2", text: "Put phone on Do Not Disturb for 20 minutes", done: true, isDemoSample: true },
        { id: "s3", text: "Have an early night", done: false, isDemoSample: true },
      ],
      appointmentPreview: { title: "GP telephone appointment", when: "Tomorrow morning" },
      budget: {
        income: 1850,
        bills: [
          { id: "bill1", name: "Rent", amount: 950, paid: true, isDemoSample: true },
          { id: "bill2", name: "Broadband", amount: 32, paid: false, isDemoSample: true },
          { id: "bill3", name: "Mobile phone", amount: 24, paid: false, isDemoSample: true },
          { id: "bill4", name: "Streaming", amount: 12, paid: true, isDemoSample: true },
          { id: "bill5", name: "Car insurance", amount: 61, paid: false, isDemoSample: true },
        ],
      },
    };
  }

  function countVisitor(list) {
    return (list || []).filter(function (item) {
      return item && item.isVisitorCreated;
    }).length;
  }

  function habitStats(habits, days) {
    var total = 0;
    var done = 0;
    var bestStreak = 0;
    (habits || []).forEach(function (habit) {
      var s = habitStreak(habit, days);
      if (s > bestStreak) bestStreak = s;
      days.forEach(function (day) {
        total += 1;
        if (habit.logs && habit.logs[day]) done += 1;
      });
    });
    var pct = total ? Math.round((done / total) * 100) : 0;
    return { done: done, total: total, pct: pct, streak: bestStreak };
  }

  function billTotals(bills) {
    var paid = 0;
    var unpaid = 0;
    (bills || []).forEach(function (bill) {
      if (bill.paid) paid += Number(bill.amount) || 0;
      else unpaid += Number(bill.amount) || 0;
    });
    return { paid: paid, unpaid: unpaid };
  }

  function readDemoConfig(root) {
    var el = root.querySelector("[data-adhd-demo-config]");
    if (!el) {
      var sibling = root.previousElementSibling;
      while (sibling) {
        if (sibling.matches && sibling.matches("[data-adhd-demo-config]")) {
          el = sibling;
          break;
        }
        sibling = sibling.previousElementSibling;
      }
    }
    try {
      return JSON.parse(el ? el.textContent : "{}");
    } catch (err) {
      return {};
    }
  }

  function readEmbedParams() {
    try {
      return new URLSearchParams(window.location.search);
    } catch (err) {
      return { get: function () { return null; } };
    }
  }

  function initDemo(root) {
    if (!root || root.dataset.demoInitialized === "true") return;
    root.dataset.demoInitialized = "true";

    var embedParams = readEmbedParams();
    var embedMode = embedParams.get("embed") === "1";

    try {
      if (embedMode) {
        document.body.classList.add("adhd-demo-embed");
      }
    } catch (e) {}

    var config = readDemoConfig(root);

    config = Object.assign({}, DEMO_FRAMEWORK, config);
    if (!config.storageKey) config.storageKey = config.storageNamespace || STORAGE_KEY;

    var limits = Object.assign({}, DEMO_LIMITS, config.limits || {});
    var storageKey = config.storageKey;
    var memoryState = null;
    var storageOk = true;
    var activeModal = null;
    var activeTourStep = -1;
    var lastFocus = null;
    var ctaResizeObserver = null;
    var abortController = new AbortController();
    var signal = abortController.signal;

    var els = {
      content: root.querySelector("[data-adhd-demo-content]"),
      loading: root.querySelector("[data-adhd-demo-loading]"),
      main: root.querySelector("[data-adhd-demo-main]"),
      pageHead: root.querySelector("[data-adhd-demo-page-head]"),
      eyebrow: root.querySelector("[data-adhd-demo-eyebrow]"),
      pageTitle: root.querySelector("[data-adhd-demo-page-title]"),
      pageSub: root.querySelector("[data-adhd-demo-page-sub]"),
      date: root.querySelector("[data-adhd-demo-date]"),
      palettes: root.querySelector("[data-adhd-demo-palettes]"),
      calm: root.querySelector("[data-adhd-demo-calm]"),
      dark: root.querySelector("[data-adhd-demo-dark]"),
      menu: root.querySelector("[data-adhd-demo-menu]"),
      sidebar: root.querySelector("[data-adhd-demo-sidebar]"),
      backdrop: root.querySelector("[data-adhd-demo-backdrop]"),
      toast: root.querySelector("[data-adhd-demo-toast]"),
      live: root.querySelector("[data-adhd-demo-live]"),
      badge: root.querySelector("[data-adhd-demo-badge]"),
      compare: root.querySelector("[data-adhd-demo-compare]"),
      storageWarn: root.querySelector("[data-adhd-demo-storage-warn]"),
      ctaBar: root.querySelector("[data-adhd-demo-cta-bar]"),
    };

    function syncCtaHeight() {
      var height = els.ctaBar ? Math.ceil(els.ctaBar.getBoundingClientRect().height) : 0;
      root.style.setProperty("--apd-cta-h", height + "px");
    }

    if (els.ctaBar && "ResizeObserver" in window) {
      ctaResizeObserver = new ResizeObserver(syncCtaHeight);
      ctaResizeObserver.observe(els.ctaBar);
    } else {
      window.addEventListener("resize", syncCtaHeight, { signal: signal });
    }
    syncCtaHeight();

    function announce(message) {
      if (els.live) els.live.textContent = message;
    }

    function toast(message) {
      if (!els.toast) return;
      els.toast.hidden = false;
      els.toast.textContent = message;
      window.clearTimeout(toast._t);
      toast._t = window.setTimeout(function () {
        els.toast.hidden = true;
      }, 3200);
      announce(message);
    }

    function readStorage(store, key) {
      try {
        return store.getItem(key);
      } catch (err) {
        return null;
      }
    }

    function writeStorage(store, key, value) {
      try {
        store.setItem(key, value);
        return true;
      } catch (err) {
        return false;
      }
    }

    function removeStorage(store, key) {
      try {
        store.removeItem(key);
      } catch (err) {}
    }

    function migrateLegacyStorage() {
      var migrated = readStorage(window.localStorage, storageKey);
      if (migrated) return migrated;
      var i;
      for (i = 0; i < LEGACY_STORAGE_KEYS.length; i += 1) {
        var legacyKey = LEGACY_STORAGE_KEYS[i];
        migrated =
          readStorage(window.sessionStorage, legacyKey) ||
          readStorage(window.localStorage, legacyKey);
        if (migrated) {
          writeStorage(window.localStorage, storageKey, migrated);
          removeStorage(window.sessionStorage, legacyKey);
          removeStorage(window.localStorage, legacyKey);
          return migrated;
        }
      }
      return null;
    }

    function clearLegacyStorage() {
      var i;
      for (i = 0; i < LEGACY_STORAGE_KEYS.length; i += 1) {
        removeStorage(window.sessionStorage, LEGACY_STORAGE_KEYS[i]);
        removeStorage(window.localStorage, LEGACY_STORAGE_KEYS[i]);
      }
      removeStorage(window.sessionStorage, LEGACY_WELCOME_KEY);
      removeStorage(window.localStorage, LEGACY_WELCOME_KEY);
    }

    function loadDemoState() {
      try {
        var raw = migrateLegacyStorage();
        if (!raw) return createDemoState();
        var parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== "object") return createDemoState();
        if (!parsed.schemaVersion || parsed.schemaVersion < DEMO_FRAMEWORK.schemaVersion) {
          parsed.schemaVersion = DEMO_FRAMEWORK.schemaVersion;
          if (typeof parsed.tourCompleted !== "boolean") parsed.tourCompleted = false;
        }
        return parsed;
      } catch (err) {
        storageOk = false;
        if (!memoryState) memoryState = createDemoState();
        return memoryState;
      }
    }

    function saveDemoState(state) {
      memoryState = state;
      if (!storageOk) return;
      if (!writeStorage(window.localStorage, storageKey, JSON.stringify(state))) {
        storageOk = false;
        toast("Saving is unavailable in this browser, but you can still explore the demo.");
        if (els.storageWarn) showEl(els.storageWarn);
      }
    }

    function resetDemoState() {
      removeStorage(window.localStorage, storageKey);
      clearLegacyStorage();
      memoryState = createDemoState();
      storageOk = true;
      activeTourStep = -1;
      return memoryState;
    }

    var state = loadDemoState();
    ensureDailyState(state);
    try {
      if (
        readStorage(window.sessionStorage, LEGACY_WELCOME_KEY) === "1" ||
        readStorage(window.localStorage, LEGACY_WELCOME_KEY) === "1"
      ) {
        state.welcomeDismissed = true;
        saveDemoState(state);
      }
      clearLegacyStorage();
    } catch (err) {}
    if (!storageOk) {
      toast("Temporary saving is unavailable in this browser, but you can still explore the demo.");
    }

    function ensureDailyState(s) {
      if (!s.today || typeof s.today !== "object") {
        s.today = { focus: "", priorities: ["", "", ""], notes: "" };
      }
      while ((s.today.priorities || []).length < 3) s.today.priorities.push("");
      s.today.priorities = s.today.priorities.slice(0, 3);
      if (!s.daily || typeof s.daily !== "object") s.daily = {};
      if (typeof s.daily.brainDump !== "string") s.daily.brainDump = "";
      if (!Array.isArray(s.daily.taskLines)) s.daily.taskLines = ["", "", "", ""];
      while (s.daily.taskLines.length < 4) s.daily.taskLines.push("");
      s.daily.taskLines = s.daily.taskLines.slice(0, 4);
      if (typeof s.daily.selfCareNotes !== "string") s.daily.selfCareNotes = "";
      return s;
    }

    function demoBanner(text) {
      return '<p class="adhd-planner-demo__banner">' + escapeHtml(text) + "</p>";
    }

    function lockedWrap(lockedKey, innerHtml, extraClass) {
      return (
        '<div class="adhd-planner-demo__field--locked' +
        (extraClass ? " " + extraClass : "") +
        '" data-adhd-demo-locked data-locked="' +
        escapeHtml(lockedKey) +
        '" role="button" tabindex="0" aria-haspopup="dialog">' +
        innerHtml +
        "</div>"
      );
    }

    function lockedChip() {
      return '<span class="adhd-planner-demo__lock-chip">Full version</span>';
    }

    function money(n) {
      var symbol = config.currencySymbol || "£";
      return symbol + Number(n || 0).toFixed(n % 1 ? 2 : 0);
    }

    function applyChrome() {
      root.dataset.palette = state.settings.palette || "pastel";
      root.dataset.calm = state.settings.calmMode ? "true" : "false";
      root.dataset.dark = state.settings.darkMode ? "true" : "false";
      if (els.calm) els.calm.setAttribute("aria-pressed", state.settings.calmMode ? "true" : "false");
      if (els.dark) els.dark.setAttribute("aria-pressed", state.settings.darkMode ? "true" : "false");
      document.querySelectorAll(".adhd-planner-demo-modal-portal").forEach(function (modal) {
        modal.dataset.dark = state.settings.darkMode ? "true" : "false";
      });
      if (els.date) {
        els.date.textContent = new Date().toLocaleDateString(state.settings.dateFormat || config.locale || "en-GB", {
          weekday: "long",
          day: "numeric",
          month: "long",
          year: "numeric",
        });
      }
      if (els.badge && config.demoBadgeText) els.badge.textContent = config.demoBadgeText;
      if (els.palettes) {
        els.palettes.innerHTML = PALETTES.map(function (p) {
          return (
            '<button type="button" class="adhd-planner-demo__palette-btn' +
            (state.settings.palette === p.id ? " is-active" : "") +
            '" data-palette="' +
            escapeHtml(p.id) +
            '" aria-label="' +
            escapeHtml(p.label) +
            ' palette" style="background:' +
            escapeHtml(p.color) +
            '"><span aria-hidden="true"></span></button>'
          );
        }).join("");
      }
      root.querySelectorAll("[data-adhd-demo-nav-btn]").forEach(function (btn) {
        btn.classList.toggle("is-active", btn.getAttribute("data-page") === state.currentPage);
      });
      root.querySelectorAll("[data-adhd-demo-purchase]").forEach(function (link) {
        if (config.purchaseUrl) {
          link.setAttribute("href", config.purchaseUrl);
          link.removeAttribute("aria-disabled");
        } else {
          link.setAttribute("href", "#");
          link.setAttribute("aria-disabled", "true");
        }
      });
      if (els.storageWarn) {
        if (storageOk) hideEl(els.storageWarn);
        else showEl(els.storageWarn);
      }
    }

    function checkDemoLimit(key, list) {
      var max = limits[key];
      if (typeof max !== "number") return true;
      if (countVisitor(list) >= max) {
        openModal("limit");
        return false;
      }
      return true;
    }

    function getFocusable(container) {
      return Array.prototype.slice.call(
        container.querySelectorAll(
          'a[href], button:not([disabled]), textarea, input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      ).filter(function (el) {
        return (
          el.getAttribute("aria-hidden") !== "true" &&
          el.getAttribute("aria-disabled") !== "true" &&
          !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length)
        );
      });
    }

    function showEl(el) {
      if (!el) return;
      el.removeAttribute("hidden");
      el.hidden = false;
      el.setAttribute("aria-hidden", "false");
    }

    function hideEl(el) {
      if (!el) return;
      el.hidden = true;
      el.setAttribute("hidden", "");
      el.setAttribute("aria-hidden", "true");
    }

    function getModal(name) {
      if (activeModal && activeModal.getAttribute("data-adhd-demo-modal") === name) {
        return activeModal;
      }
      return (
        root.querySelector('[data-adhd-demo-modal="' + name + '"]') ||
        document.querySelector('[data-adhd-demo-modal="' + name + '"]')
      );
    }

    function openModal(name) {
      lastFocus = document.activeElement;
      closeModal(true);
      var modal = getModal(name);
      if (!modal) return;
      modal.classList.add("adhd-planner-demo-modal-portal");
      modal.dataset.dark = state.settings.darkMode ? "true" : "false";
      showEl(modal);
      activeModal = modal;
      root.classList.add("adhd-demo-modal-open");
      var focusables = getFocusable(modal);
      if (focusables[0]) focusables[0].focus();
    }

    function closeModal(silent) {
      document.querySelectorAll("[data-adhd-demo-modal]").forEach(function (modal) {
        hideEl(modal);
        modal.classList.remove("adhd-planner-demo-modal-portal");
      });
      activeModal = null;
      root.classList.remove("adhd-demo-modal-open");
      if (!silent && lastFocus && typeof lastFocus.focus === "function") {
        try {
          lastFocus.focus();
        } catch (err) {}
      }
    }

    function signalTourStarted() {
      try {
        if (window.parent && window.parent !== window) {
          window.parent.postMessage({ type: "ss-demo-tour-started" }, "*");
        }
      } catch (err) {}
    }

    function dismissWelcome(startTour) {
      state.welcomeDismissed = true;
      saveDemoState(state);
      clearLegacyStorage();
      closeModal(true);
      if (startTour) {
        startTourFlow(0);
      } else {
        announce("Demo ready");
      }
    }

    function renderTourStep() {
      var modal = getModal("tour");
      if (!modal || activeTourStep < 0) return;
      var step = TOUR_STEPS[activeTourStep];
      if (!step) return;
      var titleEl = modal.querySelector("[data-adhd-demo-tour-title]");
      var bodyEl = modal.querySelector("[data-adhd-demo-tour-body]");
      var countEl = modal.querySelector("[data-adhd-demo-tour-count]");
      var backBtn = modal.querySelector("[data-adhd-demo-tour-back]");
      var nextBtn = modal.querySelector("[data-adhd-demo-tour-next]");
      if (titleEl) titleEl.textContent = step.title;
      if (bodyEl) bodyEl.textContent = step.body;
      if (countEl) countEl.textContent = "Step " + (activeTourStep + 1) + " of " + TOUR_STEPS.length;
      if (backBtn) backBtn.disabled = activeTourStep === 0;
      if (nextBtn) {
        nextBtn.textContent = step.finish ? "Finish tour" : "Next";
      }
      if (step.page && state.currentPage !== step.page) {
        var targetPage = step.page;
        window.requestAnimationFrame(function () {
          if (activeTourStep >= 0) goToPage(targetPage);
        });
      }
      if (step.action === "calm-hint" && els.calm) {
        els.calm.scrollIntoView({ block: "nearest", behavior: "auto" });
      }
    }

    function startTourFlow(stepIndex) {
      state.welcomeDismissed = true;
      state.tourCompleted = false;
      activeTourStep = typeof stepIndex === "number" ? stepIndex : 0;
      saveDemoState(state);
      openModal("tour");
      if (!activeModal) {
        toast("Tour could not open. Refresh the page and try again.");
        activeTourStep = -1;
        return;
      }
      renderTourStep();
      announce("Guided tour started");
      signalTourStarted();
    }

    function endTourFlow(completed) {
      activeTourStep = -1;
      if (completed) {
        state.tourCompleted = true;
        saveDemoState(state);
        announce("Tour complete");
        toast("Tour complete — continue exploring whenever you like.");
      }
      closeModal();
    }

    function advanceTour(delta) {
      var next = activeTourStep + delta;
      if (next < 0) return;
      if (next >= TOUR_STEPS.length) {
        endTourFlow(true);
        return;
      }
      activeTourStep = next;
      renderTourStep();
    }

    function showComparison() {
      openModal("welcome");
      var compare = (activeModal && activeModal.querySelector("[data-adhd-demo-compare]")) || els.compare;
      if (compare) showEl(compare);
      announce("Product comparison shown");
    }

    function eventTarget(event) {
      var target = event.target;
      if (target && target.nodeType === 3) target = target.parentElement;
      return target instanceof Element ? target : null;
    }

    function isDemoEventTarget(target) {
      return !!(
        target &&
        (root.contains(target) ||
          target.closest("[data-adhd-demo-modal]") ||
          target.closest(".adhd-planner-demo-modal-portal"))
      );
    }

    function openUpgradeModal(key) {
      var body = root.querySelector("[data-adhd-demo-upgrade-body]");
      var map = config.lockedFeatures || {};
      if (body) {
        body.textContent =
          map[key] || "This feature is included in the full ADHD Life Planner.";
      }
      openModal("upgrade");
    }

    function setMenuOpen(open) {
      if (!els.sidebar || !els.menu) return;
      els.sidebar.classList.toggle("is-open", open);
      if (els.backdrop) els.backdrop.hidden = !open;
      els.menu.setAttribute("aria-expanded", open ? "true" : "false");
      els.menu.setAttribute("aria-label", open ? "Close navigation menu" : "Open navigation menu");
    }

    function goToPage(page) {
      if (!PAGE_META[page]) return;
      state.currentPage = page;
      saveDemoState(state);
      setMenuOpen(false);
      renderCurrentPage();
      window.requestAnimationFrame(function () {
        var behavior = window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth";
        if (els.main) els.main.scrollTo({ top: 0, behavior: behavior });
        root.scrollIntoView({ block: "start", behavior: behavior });
      });
    }

    function renderCalmHome() {
      var openTasks = state.tasks.filter(function (t) {
        return !t.done;
      });
      var next = openTasks[0] || null;
      var top = openTasks.slice(0, 3);
      return (
        '<div class="adhd-planner-demo__calm-home">' +
        '<div class="adhd-planner-demo__calm-callout"><strong>Calm mode is on.</strong> Just the essentials — for low-energy or overwhelmed days. Turn it off anytime from the top bar.</div>' +
        '<div class="adhd-planner-demo__card adhd-planner-demo__calm-card"><h3>Today’s focus</h3>' +
        (state.today.focus
          ? '<p class="adhd-planner-demo__calm-focus">' + escapeHtml(state.today.focus) + "</p>"
          : '<p class="adhd-planner-demo__muted">One gentle line is enough. What matters most today?</p>') +
        '<button type="button" class="adhd-planner-demo__btn adhd-planner-demo__btn--ghost" data-adhd-demo-nav-btn data-page="today">Edit today’s focus</button></div>' +
        '<div class="adhd-planner-demo__card adhd-planner-demo__calm-card"><h3>Your next small action</h3>' +
        (next
          ? '<p class="adhd-planner-demo__calm-focus">' +
            escapeHtml(next.title) +
            '</p><button type="button" class="adhd-planner-demo__btn adhd-planner-demo__btn--primary" data-adhd-demo-nav-btn data-page="tasks">Go to Task Hub</button>'
          : '<p class="adhd-planner-demo__muted">Nothing queued right now. That is okay.</p><button type="button" class="adhd-planner-demo__btn adhd-planner-demo__btn--ghost" data-adhd-demo-nav-btn data-page="tasks">Open Task Hub</button>') +
        "</div>" +
        '<div class="adhd-planner-demo__card adhd-planner-demo__calm-card"><h3>Top tasks</h3>' +
        (top.length
          ? '<ul class="adhd-planner-demo__list">' +
            top
              .map(function (task) {
                return (
                  '<li class="adhd-planner-demo__item"><input class="adhd-planner-demo__check" type="checkbox" data-task-toggle="' +
                  escapeHtml(task.id) +
                  '"><div class="adhd-planner-demo__item-body"><span class="adhd-planner-demo__item-title">' +
                  escapeHtml(task.title) +
                  "</span></div></li>"
                );
              })
              .join("") +
            "</ul>"
          : '<p class="adhd-planner-demo__muted">No open tasks — your list is clear.</p>') +
        "</div>" +
        '<div class="adhd-planner-demo__card adhd-planner-demo__calm-card adhd-planner-demo__calm-card--soft"><h3>Gentle next steps</h3><p class="adhd-planner-demo__muted">Keep it light. Pick one place to go.</p><div class="adhd-planner-demo__row-actions">' +
        '<button type="button" class="adhd-planner-demo__btn adhd-planner-demo__btn--ghost" data-adhd-demo-nav-btn data-page="today">Today</button>' +
        '<button type="button" class="adhd-planner-demo__btn adhd-planner-demo__btn--ghost" data-adhd-demo-nav-btn data-page="habits">Habits</button>' +
        '<button type="button" class="adhd-planner-demo__btn adhd-planner-demo__btn--ghost" data-adhd-demo-nav-btn data-page="selfcare">Self-care</button>' +
        "</div></div></div>"
      );
    }

    function renderDashboard() {
      if (state.settings.calmMode) return renderCalmHome();
      var days = weekDates(state.settings.weekStartsOn);
      var hs = habitStats(state.habits, days);
      var tasksOpen = state.tasks.filter(function (t) {
        return !t.done;
      }).length;
      var tasksDone = state.tasks.filter(function (t) {
        return t.done;
      }).length;
      var totals = billTotals(state.budget.bills);
      var progress = state.tasks.length ? Math.round((tasksDone / state.tasks.length) * 100) : 0;
      var wins = state.tasks
        .filter(function (t) {
          return t.done;
        })
        .slice(-4)
        .reverse();
      var available = Number(state.budget.income || 0) - Number(totals.paid + totals.unpaid || 0);
      return (
        demoBanner("Home matches the complete planner’s calm overview. Some panels are preview-only.") +
        '<div class="adhd-planner-demo__grid adhd-planner-demo__grid--stats">' +
        '<div class="adhd-planner-demo__card"><h3>Open tasks</h3><span class="adhd-planner-demo__stat-value">' +
        tasksOpen +
        '</span></div>' +
        '<div class="adhd-planner-demo__card"><h3>Completed</h3><span class="adhd-planner-demo__stat-value">' +
        tasksDone +
        '</span></div>' +
        '<div class="adhd-planner-demo__card"><h3>Habits this week</h3><span class="adhd-planner-demo__stat-value">' +
        hs.pct +
        '%</span><p class="adhd-planner-demo__muted">' +
        hs.done +
        " of " +
        hs.total +
        " · streak " +
        hs.streak +
        ' days</p></div>' +
        '<div class="adhd-planner-demo__card"><h3>Brain dump</h3><span class="adhd-planner-demo__stat-value">' +
        state.brainDumps.length +
        "</span></div></div>" +
        '<div class="adhd-planner-demo__grid adhd-planner-demo__grid--2" style="margin-top:14px">' +
        '<div class="adhd-planner-demo__card"><h3>Today’s focus</h3><p>' +
        escapeHtml(state.today.focus) +
        '</p><h3 style="margin-top:14px">Top 3 priorities</h3><ol>' +
        state.today.priorities
          .map(function (p) {
            return "<li>" + escapeHtml(p) + "</li>";
          })
          .join("") +
        '</ol><div class="adhd-planner-demo__progress" aria-hidden="true"><span style="width:' +
        progress +
        '%"></span></div><p class="adhd-planner-demo__muted">Overall task progress: ' +
        progress +
        '%</p><div class="adhd-planner-demo__row-actions" style="margin-top:12px"><button type="button" class="adhd-planner-demo__btn adhd-planner-demo__btn--tiny adhd-planner-demo__btn--ghost" data-adhd-demo-nav-btn data-page="today">Open Today</button><button type="button" class="adhd-planner-demo__btn adhd-planner-demo__btn--tiny adhd-planner-demo__btn--ghost" data-adhd-demo-nav-btn data-page="daily">Open Daily Plan</button></div></div>' +
        '<div class="adhd-planner-demo__card"><h3>Money snapshot</h3><p>Income: <strong>' +
        money(state.budget.income) +
        "</strong></p><p>Paid: <strong>" +
        money(totals.paid) +
        "</strong></p><p>Still to pay: <strong>" +
        money(totals.unpaid) +
        "</strong></p><p class=\"adhd-planner-demo__muted\">After planned bills: <strong>" +
        money(Math.max(0, available)) +
        '</strong></p><div class="adhd-planner-demo__row-actions"><button type="button" class="adhd-planner-demo__btn adhd-planner-demo__btn--tiny adhd-planner-demo__btn--ghost" data-adhd-demo-nav-btn data-page="budget">Open Budget</button></div></div></div>' +
        '<div class="adhd-planner-demo__grid adhd-planner-demo__grid--2" style="margin-top:14px">' +
        '<div class="adhd-planner-demo__card"><h3>Recent wins</h3>' +
        (wins.length
          ? '<ul class="adhd-planner-demo__list">' +
            wins
              .map(function (t) {
                return '<li class="adhd-planner-demo__item is-done"><span class="adhd-planner-demo__item-title">✓ ' + escapeHtml(t.title) + "</span></li>";
              })
              .join("") +
            "</ul>"
          : '<p class="adhd-planner-demo__muted">Tick a task to see wins here.</p>') +
        "</div>" +
        lockedWrap(
          "appointments",
          "<h3>Upcoming appointments " +
            lockedChip() +
            "</h3><p>" +
            escapeHtml(state.appointmentPreview.title) +
            " · " +
            escapeHtml(state.appointmentPreview.when) +
            '</p><p class="adhd-planner-demo__muted">Full appointment management unlocks in the complete planner.</p>',
          "adhd-planner-demo__card"
        ) +
        "</div>" +
        '<div class="adhd-planner-demo__grid adhd-planner-demo__grid--2" style="margin-top:14px">' +
        lockedWrap(
          "energy",
          "<h3>Energy / mood glance " +
            lockedChip() +
            '</h3><p>Mood: Okay · Energy: Low</p><p class="adhd-planner-demo__muted">Check-in history unlocks in the complete planner.</p>',
          "adhd-planner-demo__card"
        ) +
        lockedWrap(
          "weekly",
          "<h3>Weekly plan glance " +
            lockedChip() +
            '</h3><p>Focus: Keep evenings quieter</p><p class="adhd-planner-demo__muted">Saved weeks and day blocks unlock in the complete planner.</p>',
          "adhd-planner-demo__card"
        ) +
        "</div>"
      );
    }

    function renderToday() {
      return (
        demoBanner("Today uses the same calm layout as the complete planner. Editable fields save automatically in this demo session.") +
        '<div class="adhd-planner-demo__card"><h3>Today’s focus</h3>' +
        '<div class="adhd-planner-demo__field"><label for="apd-focus">One thing that matters</label>' +
        '<input class="adhd-planner-demo__input" id="apd-focus" data-today-focus maxlength="120" value="' +
        escapeHtml(state.today.focus) +
        '" placeholder="One thing that matters"></div>' +
        '<div class="adhd-planner-demo__field"><span class="adhd-planner-demo__field-label">Top 3</span>' +
        [0, 1, 2]
          .map(function (i) {
            return (
              '<input class="adhd-planner-demo__input" style="margin-top:6px" id="apd-pri-' +
              i +
              '" data-today-priority="' +
              i +
              '" maxlength="120" aria-label="Priority ' +
              (i + 1) +
              '" value="' +
              escapeHtml(state.today.priorities[i] || "") +
              '">'
            );
          })
          .join("") +
        "</div>" +
        '<div class="adhd-planner-demo__field"><label for="apd-notes">Notes</label>' +
        '<textarea class="adhd-planner-demo__textarea" id="apd-notes" data-today-notes maxlength="500">' +
        escapeHtml(state.today.notes || "") +
        "</textarea></div>" +
        '<div class="adhd-planner-demo__row-actions">' +
        '<button type="button" class="adhd-planner-demo__btn adhd-planner-demo__btn--primary" data-adhd-demo-locked data-locked="daily-save" aria-haspopup="dialog">Save today ' +
        lockedChip() +
        "</button>" +
        '<button type="button" class="adhd-planner-demo__btn adhd-planner-demo__btn--ghost" data-adhd-demo-nav-btn data-page="daily">Open Daily Plan</button>' +
        "</div>" +
        '<p class="adhd-planner-demo__muted">In the complete planner, Save stores a named today entry you can reopen later. This demo keeps fields in temporary session storage.</p></div>' +
        lockedWrap(
          "daily-history",
          "<h3>Saved today entries " +
            lockedChip() +
            '</h3><p class="adhd-planner-demo__muted" style="margin:0">Past Today saves appear here in the complete planner.</p>',
          "adhd-planner-demo__card"
        ).replace('class="adhd-planner-demo__field--locked', 'style="margin-top:14px" class="adhd-planner-demo__field--locked')
      );
    }

    function renderDaily() {
      ensureDailyState(state);
      var priorities = state.today.priorities || ["", "", ""];
      var taskLines = state.daily.taskLines || ["", "", "", ""];
      var apptPreview =
        (state.appointmentPreview && state.appointmentPreview.title
          ? state.appointmentPreview.title +
            (state.appointmentPreview.when ? " · " + state.appointmentPreview.when : "")
          : "GP telephone appointment · Tomorrow morning");

      return (
        '<div class="adhd-planner-demo__card">' +
        '<p class="adhd-planner-demo__banner">This demo uses the same Daily Plan fields as the complete planner. Only today’s editable fields can be changed — locked sections show what the full version unlocks.</p>' +
        "<h3>Daily entry</h3>" +
        '<div class="adhd-planner-demo__field"><label for="apd-daily-date">Date</label>' +
        '<input class="adhd-planner-demo__input" id="apd-daily-date" type="date" data-daily-date value="' +
        todayKey() +
        '"></div>' +
        '<div class="adhd-planner-demo__row-actions">' +
        '<button type="button" class="adhd-planner-demo__btn adhd-planner-demo__btn--primary" data-adhd-demo-locked data-locked="daily-save" aria-haspopup="dialog">Save Entry <span class="adhd-planner-demo__lock-chip">Full version</span></button>' +
        '<button type="button" class="adhd-planner-demo__btn adhd-planner-demo__btn--ghost" data-adhd-demo-locked data-locked="daily-history" aria-haspopup="dialog">New Entry <span class="adhd-planner-demo__lock-chip">Full version</span></button>' +
        '<button type="button" class="adhd-planner-demo__btn adhd-planner-demo__btn--ghost" data-adhd-demo-locked data-locked="daily-history" aria-haspopup="dialog">Clear Current Form <span class="adhd-planner-demo__lock-chip">Full version</span></button>' +
        "</div>" +
        '<p class="adhd-planner-demo__muted">In this demo, editable fields save automatically for today only. Multi-day history stays in the complete planner.</p>' +
        "</div>" +
        '<div class="adhd-planner-demo__card" style="margin-top:14px">' +
        "<h3>Planner fields</h3>" +
        '<div class="adhd-planner-demo__field"><label for="apd-daily-focus">Today’s focus</label>' +
        '<input class="adhd-planner-demo__input" id="apd-daily-focus" data-today-focus maxlength="120" value="' +
        escapeHtml(state.today.focus || "") +
        '"></div>' +
        '<div class="adhd-planner-demo__field"><span class="adhd-planner-demo__field-label">Top 3 priorities</span>' +
        [0, 1, 2]
          .map(function (i) {
            return (
              '<input class="adhd-planner-demo__input" style="margin-top:6px" aria-label="Priority ' +
              (i + 1) +
              '" data-today-priority="' +
              i +
              '" maxlength="120" value="' +
              escapeHtml(priorities[i] || "") +
              '">'
            );
          })
          .join("") +
        "</div>" +
        '<div class="adhd-planner-demo__field"><label for="apd-daily-brain">Brain dump</label>' +
        '<textarea class="adhd-planner-demo__textarea" id="apd-daily-brain" data-daily-brain maxlength="500">' +
        escapeHtml(state.daily.brainDump || "") +
        "</textarea></div>" +
        '<div class="adhd-planner-demo__field"><span class="adhd-planner-demo__field-label">Tasks (must / could)</span>' +
        [0, 1, 2, 3]
          .map(function (i) {
            return (
              '<input class="adhd-planner-demo__input" style="margin-top:6px" aria-label="Daily task line ' +
              (i + 1) +
              '" data-daily-task-line="' +
              i +
              '" maxlength="120" value="' +
              escapeHtml(taskLines[i] || "") +
              '">'
            );
          })
          .join("") +
        "</div>" +
        '<div class="adhd-planner-demo__field adhd-planner-demo__field--locked" data-adhd-demo-locked data-locked="appointments" role="button" tabindex="0" aria-haspopup="dialog">' +
        '<label for="apd-daily-appt">Appointments &amp; reminders <span class="adhd-planner-demo__lock-chip">Full version</span></label>' +
        '<textarea class="adhd-planner-demo__textarea" id="apd-daily-appt" readonly tabindex="-1">' +
        escapeHtml(apptPreview) +
        "</textarea>" +
        '<p class="adhd-planner-demo__muted">Preview only — appointment management unlocks in the complete planner.</p></div>' +
        '<div class="adhd-planner-demo__field"><label for="apd-daily-selfcare">Meals / water / self-care</label>' +
        '<textarea class="adhd-planner-demo__textarea" id="apd-daily-selfcare" data-daily-selfcare maxlength="400">' +
        escapeHtml(state.daily.selfCareNotes || "") +
        "</textarea></div>" +
        '<div class="adhd-planner-demo__field adhd-planner-demo__field--locked" data-adhd-demo-locked data-locked="energy" role="button" tabindex="0" aria-haspopup="dialog">' +
        '<label for="apd-daily-mood">Mood <span class="adhd-planner-demo__lock-chip">Full version</span></label>' +
        '<select class="adhd-planner-demo__select" id="apd-daily-mood" disabled tabindex="-1"><option>Okay</option></select></div>' +
        '<div class="adhd-planner-demo__field adhd-planner-demo__field--locked" data-adhd-demo-locked data-locked="energy" role="button" tabindex="0" aria-haspopup="dialog">' +
        '<label for="apd-daily-energy">Energy <span class="adhd-planner-demo__lock-chip">Full version</span></label>' +
        '<select class="adhd-planner-demo__select" id="apd-daily-energy" disabled tabindex="-1"><option>Low</option></select></div>' +
        '<div class="adhd-planner-demo__field"><label for="apd-daily-notes">Notes</label>' +
        '<textarea class="adhd-planner-demo__textarea" id="apd-daily-notes" data-today-notes maxlength="500">' +
        escapeHtml(state.today.notes || "") +
        "</textarea></div>" +
        '<div class="adhd-planner-demo__field adhd-planner-demo__field--locked" data-adhd-demo-locked data-locked="daily-reflection" role="button" tabindex="0" aria-haspopup="dialog">' +
        '<label for="apd-daily-reflect">End-of-day reflection <span class="adhd-planner-demo__lock-chip">Full version</span></label>' +
        '<textarea class="adhd-planner-demo__textarea" id="apd-daily-reflect" readonly tabindex="-1" placeholder="What went okay today?"></textarea>' +
        '<p class="adhd-planner-demo__muted">Reflection history is included in the complete planner.</p></div>' +
        "</div>" +
        '<div class="adhd-planner-demo__card adhd-planner-demo__field--locked" style="margin-top:14px" data-adhd-demo-locked data-locked="daily-history" role="button" tabindex="0" aria-haspopup="dialog">' +
        '<h3>Saved daily entries <span class="adhd-planner-demo__lock-chip">Full version</span></h3>' +
        '<p class="adhd-planner-demo__muted" style="margin:0">The complete planner keeps every day you save so you can reopen past plans anytime. This demo keeps today’s editable fields in temporary session storage only.</p>' +
        "</div>"
      );
    }

    function renderTasks() {
      var filter = state._taskFilter === "done" ? "done" : "open";
      var list = state.tasks.filter(function (task) {
        return filter === "done" ? task.done : !task.done;
      });
      return (
        demoBanner("Task Hub uses the same layout as the complete planner. Add, complete and edit demo tasks here — due dates and extra tools unlock in the complete planner.") +
        '<div class="adhd-planner-demo__card"><div class="adhd-planner-demo__filters">' +
        ["open", "done"]
          .map(function (f) {
            return (
              '<button type="button" class="adhd-planner-demo__btn adhd-planner-demo__btn--tiny adhd-planner-demo__btn--ghost" data-task-filter="' +
              f +
              '"' +
              (filter === f ? ' aria-current="true"' : "") +
              ">" +
              (f === "open" ? "Open" : "Completed") +
              "</button>"
            );
          })
          .join("") +
        '</div><div class="adhd-planner-demo__row-actions">' +
        '<input class="adhd-planner-demo__input adhd-planner-demo__new-entry" data-task-new maxlength="120" placeholder="Add a demo task">' +
        '<button type="button" class="adhd-planner-demo__btn adhd-planner-demo__btn--primary" data-task-add>Add task</button>' +
        "</div>" +
        lockedWrap(
          "daily-other",
          '<label>Due date <span class="adhd-planner-demo__lock-chip">Full version</span></label><input class="adhd-planner-demo__input" type="date" disabled tabindex="-1"><p class="adhd-planner-demo__muted">Optional due dates unlock in the complete planner.</p>',
          ""
        ) +
        '<ul class="adhd-planner-demo__list">' +
        list
          .map(function (task) {
            return (
              '<li class="adhd-planner-demo__item' +
              (task.done ? " is-done" : "") +
              '"><input class="adhd-planner-demo__check" type="checkbox" data-task-toggle="' +
              escapeHtml(task.id) +
              '" ' +
              (task.done ? "checked" : "") +
              '><div class="adhd-planner-demo__item-body"><input class="adhd-planner-demo__item-title" data-task-title="' +
              escapeHtml(task.id) +
              '" maxlength="120" value="' +
              escapeHtml(task.title) +
              '"></div><div class="adhd-planner-demo__item-actions">' +
              (task.isVisitorCreated || !task.isDemoSample
                ? '<button type="button" class="adhd-planner-demo__btn adhd-planner-demo__btn--tiny adhd-planner-demo__btn--ghost" data-task-delete="' +
                  escapeHtml(task.id) +
                  '">Delete</button>'
                : '<button type="button" class="adhd-planner-demo__btn adhd-planner-demo__btn--tiny adhd-planner-demo__btn--ghost" data-adhd-demo-locked data-locked="daily-other" aria-haspopup="dialog">⋯</button>') +
              "</div></li>"
            );
          })
          .join("") +
        (list.length ? "" : '<li class="adhd-planner-demo__muted" style="list-style:none">Nothing here yet.</li>') +
        '</ul><p class="adhd-planner-demo__muted">Visitor-created tasks: ' +
        countVisitor(state.tasks) +
        " / " +
        limits.customTasks +
        "</p></div>"
      );
    }

    function renderBrain() {
      return (
        demoBanner("Brain Dump uses the complete planner’s quick-capture layout. Add and edit entries here — sorting into tasks or goals unlocks in the complete planner.") +
        '<div class="adhd-planner-demo__card"><div class="adhd-planner-demo__row-actions">' +
        '<input class="adhd-planner-demo__input adhd-planner-demo__new-entry" data-brain-new maxlength="160" placeholder="Add a brain dump entry">' +
        '<button type="button" class="adhd-planner-demo__btn adhd-planner-demo__btn--primary" data-brain-add>Add entry</button>' +
        "</div>" +
        lockedWrap(
          "daily-other",
          '<label>Date <span class="adhd-planner-demo__lock-chip">Full version</span></label><input class="adhd-planner-demo__input" type="date" disabled tabindex="-1"><p class="adhd-planner-demo__muted">Dating notes for weekly rollup unlocks in the complete planner.</p>',
          ""
        ) +
        '<ul class="adhd-planner-demo__list">' +
        state.brainDumps
          .map(function (item) {
            return (
              '<li class="adhd-planner-demo__item"><div class="adhd-planner-demo__item-body"><input class="adhd-planner-demo__item-title" data-brain-text="' +
              escapeHtml(item.id) +
              '" maxlength="160" value="' +
              escapeHtml(item.text) +
              '"></div>' +
              (item.isVisitorCreated || !item.isDemoSample
                ? '<button type="button" class="adhd-planner-demo__btn adhd-planner-demo__btn--tiny adhd-planner-demo__btn--ghost" data-brain-delete="' +
                  escapeHtml(item.id) +
                  '">Delete</button>'
                : "") +
              "</li>"
            );
          })
          .join("") +
        '</ul><p class="adhd-planner-demo__muted">Visitor-created entries: ' +
        countVisitor(state.brainDumps) +
        " / " +
        limits.customBrainDumps +
        "</p></div>"
      );
    }

    function renderHabits() {
      var days = weekDates(state.settings.weekStartsOn);
      var hs = habitStats(state.habits, days);
      var locale = state.settings.dateFormat || config.locale || "en-GB";
      return (
        demoBanner("Habits & Routines uses the same weekly grid as the complete planner. This demo shows the current week only — browsing other weeks unlocks in the complete planner.") +
        '<div class="adhd-planner-demo__card"><div class="adhd-planner-demo__filters">' +
        '<button type="button" class="adhd-planner-demo__btn adhd-planner-demo__btn--tiny adhd-planner-demo__btn--ghost" data-adhd-demo-locked data-locked="weekly" aria-haspopup="dialog">‹ Previous week</button>' +
        '<span class="adhd-planner-demo__muted" style="align-self:center">This week</span>' +
        '<button type="button" class="adhd-planner-demo__btn adhd-planner-demo__btn--tiny adhd-planner-demo__btn--ghost" data-adhd-demo-locked data-locked="weekly" aria-haspopup="dialog">Next week ›</button>' +
        '</div><p class="adhd-planner-demo__muted">This week: ' +
        hs.pct +
        "% complete · streak " +
        hs.streak +
        ' day(s)</p><div class="adhd-planner-demo__habit-wrap"><table class="adhd-planner-demo__habit-table"><thead><tr><th>Habit</th>' +
        days
          .map(function (d) {
            return "<th>" + escapeHtml(dayLabel(d, locale)) + "</th>";
          })
          .join("") +
        "<th>Streak</th></tr></thead><tbody>" +
        state.habits
          .map(function (habit) {
            var streak = habitStreak(habit, days);
            return (
              "<tr><td>" +
              (habit.isVisitorCreated
                ? '<input class="adhd-planner-demo__item-title" data-habit-name="' +
                  escapeHtml(habit.id) +
                  '" maxlength="80" value="' +
                  escapeHtml(habit.name) +
                  '"> <button type="button" class="adhd-planner-demo__btn adhd-planner-demo__btn--tiny adhd-planner-demo__btn--ghost" data-habit-delete="' +
                  escapeHtml(habit.id) +
                  '">Remove</button>'
                : escapeHtml(habit.name)) +
              "</td>" +
              days
                .map(function (day) {
                  var on = !!(habit.logs && habit.logs[day]);
                  return (
                    '<td><button type="button" class="adhd-planner-demo__habit-cell' +
                    (on ? " is-on" : "") +
                    '" data-habit-toggle="' +
                    escapeHtml(habit.id) +
                    '" data-day="' +
                    escapeHtml(day) +
                    '" aria-pressed="' +
                    (on ? "true" : "false") +
                    '" aria-label="' +
                    escapeHtml(habit.name) +
                    " on " +
                    escapeHtml(day) +
                    '">' +
                    (on ? "✓" : "") +
                    "</button></td>"
                  );
                })
                .join("") +
              "<td>" +
              (streak ? streak + " 🔥" : "—") +
              "</td></tr>"
            );
          })
          .join("") +
        '</tbody></table></div><div class="adhd-planner-demo__row-actions" style="margin-top:16px">' +
        '<input class="adhd-planner-demo__input adhd-planner-demo__new-entry" data-habit-new maxlength="80" placeholder="Add one demo habit" aria-label="New habit name">' +
        '<button type="button" class="adhd-planner-demo__btn adhd-planner-demo__btn--primary" data-habit-add>Add habit</button></div>' +
        '<p class="adhd-planner-demo__muted">Tap a day circle to tick or untick. Visitor-created habits: ' +
        countVisitor(state.habits) +
        " / " +
        limits.customHabits +
        "</p></div>"
      );
    }

    function renderSelfCare() {
      return (
        demoBanner("Self-Care uses the same checklist layout as the complete planner. Add and tick off small acts of care below.") +
        '<div class="adhd-planner-demo__card"><div class="adhd-planner-demo__row-actions"><input class="adhd-planner-demo__input adhd-planner-demo__new-entry" data-selfcare-new maxlength="120" placeholder="Add one self-care action"><button type="button" class="adhd-planner-demo__btn adhd-planner-demo__btn--primary" data-selfcare-add>Add action</button></div><ul class="adhd-planner-demo__list">' +
        state.selfCare
          .map(function (item) {
            return (
              '<li class="adhd-planner-demo__item' +
              (item.done ? " is-done" : "") +
              '"><input class="adhd-planner-demo__check" type="checkbox" data-selfcare-toggle="' +
              escapeHtml(item.id) +
              '" ' +
              (item.done ? "checked" : "") +
              '><div class="adhd-planner-demo__item-body"><span class="adhd-planner-demo__item-title">' +
              escapeHtml(item.text) +
              "</span></div>" +
              (item.isVisitorCreated || !item.isDemoSample
                ? '<button type="button" class="adhd-planner-demo__btn adhd-planner-demo__btn--tiny adhd-planner-demo__btn--ghost" data-selfcare-delete="' +
                  escapeHtml(item.id) +
                  '">Remove</button>'
                : "") +
              "</li>"
            );
          })
          .join("") +
        '</ul><p class="adhd-planner-demo__muted">Visitor-created actions: ' +
        countVisitor(state.selfCare) +
        " / " +
        limits.customSelfCare +
        "</p></div>"
      );
    }

    function renderBudget() {
      var totals = billTotals(state.budget.bills);
      var available = Number(state.budget.income || 0) - Number((totals.paid || 0) + (totals.unpaid || 0));
      var filter = state._billFilter || "all";
      var list = state.budget.bills.filter(function (bill) {
        if (filter === "unpaid") return !bill.paid;
        if (filter === "paid") return bill.paid;
        return true;
      });
      return (
        demoBanner("Budget & Bills mirrors the complete planner’s layout. Track one month of sample bills below — multiple income sources, recurring bills and monthly history unlock in the complete planner.") +
        '<div class="adhd-planner-demo__card">' +
        '<div class="adhd-planner-demo__field adhd-planner-demo__field--locked" data-adhd-demo-locked data-locked="budget-history" role="button" tabindex="0" aria-haspopup="dialog">' +
        '<label for="apd-budget-month">Month <span class="adhd-planner-demo__lock-chip">Full version</span></label>' +
        '<select class="adhd-planner-demo__select" id="apd-budget-month" disabled tabindex="-1"><option>This month</option></select>' +
        "</div></div>" +
        '<div class="adhd-planner-demo__grid adhd-planner-demo__grid--stats" style="margin-top:14px">' +
        '<div class="adhd-planner-demo__card"><h3>Income</h3><span class="adhd-planner-demo__stat-value">' +
        money(state.budget.income) +
        '</span></div><div class="adhd-planner-demo__card"><h3>Paid</h3><span class="adhd-planner-demo__stat-value">' +
        money(totals.paid) +
        '</span></div><div class="adhd-planner-demo__card"><h3>Still to pay</h3><span class="adhd-planner-demo__stat-value">' +
        money(totals.unpaid) +
        '</span></div><div class="adhd-planner-demo__card"><h3>Available funds</h3><span class="adhd-planner-demo__stat-value">' +
        money(Math.max(0, available)) +
        "</span></div></div>" +
        '<div class="adhd-planner-demo__grid adhd-planner-demo__grid--2" style="margin-top:14px">' +
        '<div class="adhd-planner-demo__card"><h3>Income sources</h3><p>Salary — ' +
        money(state.budget.income) +
        '</p><div class="adhd-planner-demo__row-actions"><button type="button" class="adhd-planner-demo__btn adhd-planner-demo__btn--ghost" data-adhd-demo-locked data-locked="budget-income" aria-haspopup="dialog">Add income source ' +
        lockedChip() +
        "</button></div></div>" +
        lockedWrap(
          "budget-recurring",
          "<h3>Recurring bills " +
            lockedChip() +
            '</h3><p class="adhd-planner-demo__muted">Set bills to repeat monthly, weekly or yearly and see next due dates automatically in the complete planner.</p>',
          "adhd-planner-demo__card"
        ) +
        "</div>" +
        '<div class="adhd-planner-demo__card" style="margin-top:14px"><div class="adhd-planner-demo__filters">' +
        ["all", "unpaid", "paid"]
          .map(function (f) {
            return (
              '<button type="button" class="adhd-planner-demo__btn adhd-planner-demo__btn--tiny adhd-planner-demo__btn--ghost" data-bill-filter="' +
              f +
              '"' +
              (filter === f ? ' aria-current="true"' : "") +
              ">" +
              (f === "all" ? "All" : f === "unpaid" ? "Unpaid" : "Paid") +
              "</button>"
            );
          })
          .join("") +
        '</div><div class="adhd-planner-demo__row-actions">' +
        '<input class="adhd-planner-demo__input adhd-planner-demo__bill-name" data-bill-name maxlength="80" placeholder="Bill name">' +
        '<input class="adhd-planner-demo__input adhd-planner-demo__bill-control" data-bill-amount inputmode="decimal" placeholder="Amount">' +
        '<button type="button" class="adhd-planner-demo__input adhd-planner-demo__bill-control adhd-planner-demo__locked-control" data-adhd-demo-locked data-locked="budget-recurring" aria-haspopup="dialog">Due date</button>' +
        '<button type="button" class="adhd-planner-demo__input adhd-planner-demo__bill-control adhd-planner-demo__locked-control" data-adhd-demo-locked data-locked="budget-recurring" aria-haspopup="dialog">Category</button>' +
        '<button type="button" class="adhd-planner-demo__input adhd-planner-demo__bill-control adhd-planner-demo__locked-control" data-adhd-demo-locked data-locked="budget-recurring" aria-haspopup="dialog">Repeats</button>' +
        '<button type="button" class="adhd-planner-demo__btn adhd-planner-demo__btn--primary" data-bill-add>Add bill</button>' +
        '</div><ul class="adhd-planner-demo__list">' +
        list
          .map(function (bill) {
            return (
              '<li class="adhd-planner-demo__item"><input class="adhd-planner-demo__check" type="checkbox" data-bill-toggle="' +
              escapeHtml(bill.id) +
              '" ' +
              (bill.paid ? "checked" : "") +
              ' aria-label="Mark ' +
              escapeHtml(bill.name) +
              ' paid"><div class="adhd-planner-demo__item-body"><strong>' +
              escapeHtml(bill.name) +
              "</strong><p class=\"adhd-planner-demo__muted\">" +
              money(bill.amount) +
              " · " +
              (bill.paid ? "paid" : "due") +
              "</p></div></li>"
            );
          })
          .join("") +
        (list.length ? "" : '<li class="adhd-planner-demo__muted" style="list-style:none">No bills in this filter.</li>') +
        '</ul><p class="adhd-planner-demo__muted">Visitor-created bills: ' +
        countVisitor(state.budget.bills) +
        " / " +
        limits.customBills +
        "</p></div>"
      );
    }

    function renderWeeklyPreview() {
      var days = weekDates(state.settings.weekStartsOn);
      var locale = state.settings.dateFormat || config.locale || "en-GB";
      var sampleFocus = "Keep evenings quieter and get the council tax form finished";
      var sampleBlocks = ["Admin catch-up", "Rest morning", "Food shop", "GP call", "Tidy + laundry", "Family time", "Plan next week"];
      return (
        demoBanner("Weekly Plan preview — this full page is included in the complete planner. Everything below is sample content.") +
        lockedWrap(
          "weekly",
          "<h3>This week’s focus " +
            lockedChip() +
            "</h3><p>" +
            escapeHtml(sampleFocus) +
            '</p><div class="adhd-planner-demo__habit-wrap" style="margin-top:12px"><table class="adhd-planner-demo__habit-table"><thead><tr>' +
            days
              .map(function (d) {
                return "<th>" + escapeHtml(dayLabel(d, locale)) + "</th>";
              })
              .join("") +
            "</tr></thead><tbody><tr>" +
            days
              .map(function (d, i) {
                return "<td>" + escapeHtml(sampleBlocks[i] || "") + "</td>";
              })
              .join("") +
            '</tr></tbody></table></div><p class="adhd-planner-demo__muted" style="margin-top:12px">Weekly habits, saved weeks and end-of-week reflection are included in the complete planner.</p>',
          "adhd-planner-demo__card"
        )
      );
    }

    function renderEnergyPreview() {
      var sample = [
        { day: "Mon", mood: "Okay", energy: "Low" },
        { day: "Tue", mood: "Good", energy: "Medium" },
        { day: "Wed", mood: "Okay", energy: "Low" },
        { day: "Thu", mood: "Good", energy: "High" },
        { day: "Fri", mood: "Tired", energy: "Low" },
      ];
      return (
        demoBanner("Energy / Mood preview — check-ins and trend history are included in the complete planner.") +
        lockedWrap(
          "energy",
          "<h3>This week’s check-ins " +
            lockedChip() +
            '</h3><ul class="adhd-planner-demo__list">' +
            sample
              .map(function (s) {
                return (
                  '<li class="adhd-planner-demo__item"><div class="adhd-planner-demo__item-body"><strong>' +
                  escapeHtml(s.day) +
                  '</strong><p class="adhd-planner-demo__muted">Mood: ' +
                  escapeHtml(s.mood) +
                  " · Energy: " +
                  escapeHtml(s.energy) +
                  "</p></div></li>"
                );
              })
              .join("") +
            '</ul><p class="adhd-planner-demo__muted" style="margin-top:10px">Daily check-ins, trends and notes are included in the complete planner.</p>',
          "adhd-planner-demo__card"
        )
      );
    }

    function renderAppointmentsPreview() {
      var sample = [
        { title: "GP telephone appointment", when: "Tomorrow, 9:30am", notes: "Ask about the referral" },
        { title: "Dentist check-up", when: "Next Tuesday, 2:00pm", notes: "" },
        { title: "Parents’ evening", when: "In 2 weeks", notes: "Bring questions about homework" },
      ];
      return (
        demoBanner("Appointments preview — full appointment management is included in the complete planner.") +
        lockedWrap(
          "appointments",
          "<h3>Upcoming appointments " +
            lockedChip() +
            '</h3><ul class="adhd-planner-demo__list">' +
            sample
              .map(function (a) {
                return (
                  '<li class="adhd-planner-demo__item"><div class="adhd-planner-demo__item-body"><strong>' +
                  escapeHtml(a.title) +
                  '</strong><p class="adhd-planner-demo__muted">' +
                  escapeHtml(a.when) +
                  (a.notes ? " · " + escapeHtml(a.notes) : "") +
                  "</p></div></li>"
                );
              })
              .join("") +
            '</ul><p class="adhd-planner-demo__muted" style="margin-top:10px">Reminders, notes and appointment history are included in the complete planner.</p>',
          "adhd-planner-demo__card"
        )
      );
    }

    function renderGoalsPreview() {
      var sample = [
        { title: "Sort out the car insurance renewal", steps: ["Compare quotes", "Call current provider", "Confirm new policy"], pct: 33 },
        { title: "Set up a simple filing system", steps: ["Buy folders", "Sort paperwork", "Label everything"], pct: 66 },
      ];
      return (
        demoBanner("Goals preview — goal and project tracking with steps is included in the complete planner.") +
        lockedWrap(
          "goals",
          "<h3>Sample goals " +
            lockedChip() +
            "</h3>" +
            sample
              .map(function (g) {
                return (
                  '<div style="margin-bottom:14px"><p style="margin:0 0 6px"><strong>' +
                  escapeHtml(g.title) +
                  '</strong></p><div class="adhd-planner-demo__progress" aria-hidden="true"><span style="width:' +
                  g.pct +
                  '%"></span></div><ul style="margin:8px 0 0;padding-left:1.1rem;color:var(--apd-ink2);font-size:0.85rem">' +
                  g.steps
                    .map(function (s) {
                      return "<li>" + escapeHtml(s) + "</li>";
                    })
                    .join("") +
                  "</ul></div>"
                );
              })
              .join("") +
            '<p class="adhd-planner-demo__muted">Adding goals, steps and progress tracking is included in the complete planner.</p>',
          "adhd-planner-demo__card"
        )
      );
    }

    function renderDocumentsPreview() {
      var sample = [
        { title: "Insurance policy numbers", note: "Car, home and pet insurance references" },
        { title: "GP & dentist details", note: "Surgery numbers and NHS number" },
        { title: "Warranty information", note: "Washing machine, laptop, phone" },
      ];
      return (
        demoBanner("Documents preview — reference notes and file links are included in the complete planner.") +
        lockedWrap(
          "documents",
          "<h3>Sample documents " +
            lockedChip() +
            '</h3><ul class="adhd-planner-demo__list">' +
            sample
              .map(function (d) {
                return (
                  '<li class="adhd-planner-demo__item"><div class="adhd-planner-demo__item-body"><strong>' +
                  escapeHtml(d.title) +
                  '</strong><p class="adhd-planner-demo__muted">' +
                  escapeHtml(d.note) +
                  "</p></div></li>"
                );
              })
              .join("") +
            '</ul><p class="adhd-planner-demo__muted" style="margin-top:10px">Adding, editing and organising documents is included in the complete planner.</p>',
          "adhd-planner-demo__card"
        )
      );
    }

    function renderWeeklyResetPreview() {
      return (
        demoBanner("Weekly Reset preview — this guided review is included in the complete planner.") +
        lockedWrap(
          "weekly-reset",
          "<h3>Weekly reset questions " +
            lockedChip() +
            '</h3><div class="adhd-planner-demo__field"><span class="adhd-planner-demo__field-label">What went well this week?</span><p class="adhd-planner-demo__muted">Got the council tax form submitted and had one proper evening off.</p></div><div class="adhd-planner-demo__field"><span class="adhd-planner-demo__field-label">What felt hard?</span><p class="adhd-planner-demo__muted">Mornings were rushed most days.</p></div><div class="adhd-planner-demo__field"><span class="adhd-planner-demo__field-label">One thing to carry into next week</span><p class="adhd-planner-demo__muted">Prep lunches the night before.</p></div><p class="adhd-planner-demo__muted">Guided prompts, saved reviews and history are included in the complete planner.</p>',
          "adhd-planner-demo__card"
        )
      );
    }

    function renderMonthlyResetPreview() {
      return (
        demoBanner("Monthly Reset preview — this guided review is included in the complete planner.") +
        lockedWrap(
          "monthly-reset",
          "<h3>Monthly reset questions " +
            lockedChip() +
            '</h3><div class="adhd-planner-demo__field"><span class="adhd-planner-demo__field-label">Biggest win this month?</span><p class="adhd-planner-demo__muted">Finally sorted the car insurance and got a better rate.</p></div><div class="adhd-planner-demo__field"><span class="adhd-planner-demo__field-label">What is carrying over?</span><p class="adhd-planner-demo__muted">The loft clear-out is still on the list.</p></div><div class="adhd-planner-demo__field"><span class="adhd-planner-demo__field-label">Focus for next month</span><p class="adhd-planner-demo__muted">Fewer evening admin sessions, more early nights.</p></div><p class="adhd-planner-demo__muted">Monthly budgets, goal check-ins and saved reviews are included in the complete planner.</p>',
          "adhd-planner-demo__card"
        )
      );
    }

    function renderSettingsBackupPreview() {
      return (
        demoBanner("Complete settings & backup preview — export, import and sync tools are included in the complete planner.") +
        lockedWrap(
          "settings-backup",
          "<h3>Backup &amp; storage " +
            lockedChip() +
            '</h3><div class="adhd-planner-demo__row-actions"><button type="button" class="adhd-planner-demo__btn adhd-planner-demo__btn--ghost" disabled tabindex="-1">Export backup file</button><button type="button" class="adhd-planner-demo__btn adhd-planner-demo__btn--ghost" disabled tabindex="-1">Import backup file</button></div><p class="adhd-planner-demo__muted">Manual backup, restore and multi-device sync are included in the complete planner.</p>',
          "adhd-planner-demo__card"
        )
      );
    }

    function renderStart() {
      return (
        '<div class="adhd-planner-demo__card"><p>Hi ' +
        escapeHtml(state.settings.userName) +
        '. This interactive demo lets you try the calm planning flow without creating an account. Changes stay in this demo only.</p><ul><li>Explore the dashboard and tick a few tasks.</li><li>Edit today\u2019s focus and habit grid.</li><li>Locked pages show what the full ADHD Life Planner unlocks.</li><li>Reset Demo restores sample data any time.</li></ul><div class="adhd-planner-demo__row-actions"><button type="button" class="adhd-planner-demo__btn adhd-planner-demo__btn--primary" data-adhd-demo-nav-btn data-page="home">Open dashboard</button><button type="button" class="adhd-planner-demo__btn adhd-planner-demo__btn--ghost" data-adhd-demo-tour-start>Take a quick tour</button><button type="button" class="adhd-planner-demo__btn adhd-planner-demo__btn--ghost" data-adhd-demo-welcome-compare>View what is included</button></div></div>'
      );
    }

    function renderSettings() {
      return (
        demoBanner("Demo Settings controls this preview only. Backup, sync and multi-device tools are part of Complete Settings & Backup in the complete planner.") +
        '<div class="adhd-planner-demo__card"><div class="adhd-planner-demo__field"><label for="apd-palette">Colour palette</label><select class="adhd-planner-demo__select" id="apd-palette" data-setting-palette">' +
        PALETTES.map(function (p) {
          return (
            '<option value="' +
            escapeHtml(p.id) +
            '"' +
            (state.settings.palette === p.id ? " selected" : "") +
            ">" +
            escapeHtml(p.label) +
            "</option>"
          );
        }).join("") +
        '</select></div><div class="adhd-planner-demo__field"><label><input class="adhd-planner-demo__check" type="checkbox" data-setting-calm ' +
        (state.settings.calmMode ? "checked" : "") +
        '> Calm mode</label></div><div class="adhd-planner-demo__field"><label><input class="adhd-planner-demo__check" type="checkbox" data-setting-dark ' +
        (state.settings.darkMode ? "checked" : "") +
        '> Dark mode</label></div><div class="adhd-planner-demo__field"><label for="apd-datefmt">Date format</label><select class="adhd-planner-demo__select" id="apd-datefmt" data-setting-datefmt"><option value="en-GB"' +
        (state.settings.dateFormat === "en-GB" ? " selected" : "") +
        '>United Kingdom</option><option value="en-US"' +
        (state.settings.dateFormat === "en-US" ? " selected" : "") +
        '>United States</option></select></div><div class="adhd-planner-demo__field"><label for="apd-weekstart">Week starts on</label><select class="adhd-planner-demo__select" id="apd-weekstart" data-setting-weekstart"><option value="1"' +
        (Number(state.settings.weekStartsOn) === 1 ? " selected" : "") +
        '>Monday</option><option value="0"' +
        (Number(state.settings.weekStartsOn) === 0 ? " selected" : "") +
        '>Sunday</option></select></div><p class="adhd-planner-demo__muted">Demo data is stored locally under <code>' +
        escapeHtml(storageKey) +
        '</code>. It never mixes with a purchased planner. Reset Demo clears only this demo.</p><div class="adhd-planner-demo__row-actions"><button type="button" class="adhd-planner-demo__btn adhd-planner-demo__btn--ghost" data-adhd-demo-reset-open>' +
        escapeHtml(config.resetLabel || DEMO_FRAMEWORK.resetLabelDefault) +
        '</button><button type="button" class="adhd-planner-demo__btn adhd-planner-demo__btn--ghost" data-adhd-demo-tour-restart>Restart tour</button><button type="button" class="adhd-planner-demo__btn adhd-planner-demo__btn--ghost" data-adhd-demo-welcome-compare>Product comparison</button><a class="adhd-planner-demo__btn adhd-planner-demo__btn--primary" data-adhd-demo-purchase href="' +
        escapeHtml(config.purchaseUrl || "#") +
        '">' +
        escapeHtml(config.purchaseLabel || DEMO_FRAMEWORK.purchaseLabelDefault) +
        "</a></div></div>" +
        lockedWrap(
          "settings-backup",
          "<h3>Complete Settings &amp; Backup " +
            lockedChip() +
            '</h3><p class="adhd-planner-demo__muted" style="margin:0">Manual backup, restore and multi-device sync are included in the complete planner.</p>',
          "adhd-planner-demo__card"
        ).replace('class="adhd-planner-demo__field--locked', 'style="margin-top:14px" class="adhd-planner-demo__field--locked')
      );
    }

    function renderCurrentPage() {
      applyChrome();
      var meta = PAGE_META[state.currentPage] || PAGE_META.home;
      if (state.settings.calmMode && state.currentPage === "home") {
        meta = {
          eyebrow: "Calm",
          title: "Essentials only",
          sub: "A quieter view for low-energy days.",
        };
      }
      if (els.pageHead) els.pageHead.hidden = false;
      if (els.eyebrow) els.eyebrow.textContent = meta.eyebrow;
      if (els.pageTitle) els.pageTitle.textContent = meta.title;
      if (els.pageSub) els.pageSub.textContent = meta.sub;
      if (els.loading) els.loading.hidden = true;
      if (els.content) {
        els.content.hidden = false;
        var html = "";
        switch (state.currentPage) {
          case "today":
            html = renderToday();
            break;
          case "daily":
            html = renderDaily();
            break;
          case "tasks":
            html = renderTasks();
            break;
          case "brain":
            html = renderBrain();
            break;
          case "habits":
            html = renderHabits();
            break;
          case "selfcare":
            html = renderSelfCare();
            break;
          case "budget":
            html = renderBudget();
            break;
          case "weekly":
            html = renderWeeklyPreview();
            break;
          case "energy":
            html = renderEnergyPreview();
            break;
          case "appointments":
            html = renderAppointmentsPreview();
            break;
          case "goals":
            html = renderGoalsPreview();
            break;
          case "documents":
            html = renderDocumentsPreview();
            break;
          case "weekly-reset":
            html = renderWeeklyResetPreview();
            break;
          case "monthly-reset":
            html = renderMonthlyResetPreview();
            break;
          case "settings-backup":
            html = renderSettingsBackupPreview();
            break;
          case "start":
            html = renderStart();
            break;
          case "settings":
            html = renderSettings();
            break;
          default:
            html = renderDashboard();
        }
        els.content.innerHTML = html;
      }
      announce(meta.title + " loaded");
    }

    function applyTaskToggle(taskToggle) {
      if (!taskToggle) return;
      var tid = taskToggle.getAttribute("data-task-toggle");
      var done = !!taskToggle.checked;
      state.tasks.forEach(function (task) {
        if (task.id === tid) task.done = done;
      });
      var item = taskToggle.closest(".adhd-planner-demo__item");
      if (item) item.classList.toggle("is-done", done);
      saveDemoState(state);
      renderCurrentPage();
    }

    function applySelfCareToggle(selfToggle) {
      if (!selfToggle) return;
      var sid = selfToggle.getAttribute("data-selfcare-toggle");
      var done = !!selfToggle.checked;
      state.selfCare.forEach(function (item) {
        if (item.id === sid) item.done = done;
      });
      var row = selfToggle.closest(".adhd-planner-demo__item");
      if (row) row.classList.toggle("is-done", done);
      saveDemoState(state);
      renderCurrentPage();
    }

    function onPurchaseClick(event) {
      var target = eventTarget(event);
      if (!target || !isDemoEventTarget(target)) return;
      var link = target.closest("[data-adhd-demo-purchase]");
      if (!link) return;
      var href = (config.purchaseUrl || link.getAttribute("href") || "").trim();
      var disabled = link.getAttribute("aria-disabled") === "true" || !href || href === "#";
      if (disabled) {
        event.preventDefault();
        toast("Select a purchase product in the theme editor to enable this button.");
      }
    }

    function handleTourClick(target) {
      if (target.closest("[data-adhd-demo-welcome-tour]")) {
        dismissWelcome(true);
        return true;
      }
      if (target.closest("[data-adhd-demo-tour-start]") || target.closest("[data-adhd-demo-tour-restart]")) {
        startTourFlow(0);
        return true;
      }
      if (target.closest("[data-adhd-demo-tour-skip]")) {
        endTourFlow(false);
        return true;
      }
      if (target.closest("[data-adhd-demo-tour-back]")) {
        advanceTour(-1);
        return true;
      }
      if (target.closest("[data-adhd-demo-tour-next]")) {
        advanceTour(1);
        return true;
      }
      return false;
    }

    function bindModalActions() {
      root.addEventListener(
        "click",
        function (event) {
          var target = eventTarget(event);
          if (!target || !target.closest("[data-adhd-demo-modal]")) return;
          if (target.closest("[data-adhd-demo-welcome-start]")) {
            event.preventDefault();
            dismissWelcome(false);
            return;
          }
          if (target.closest("[data-adhd-demo-modal-close]")) {
            event.preventDefault();
            closeModal();
            return;
          }
          if (handleTourClick(target)) {
            event.preventDefault();
            event.stopPropagation();
          }
        },
        { capture: true, signal: signal }
      );
    }

    function onClick(event) {
      var target = eventTarget(event);
      if (!target || !isDemoEventTarget(target)) return;

      if (handleTourClick(target)) return;

      var nav = target.closest("[data-adhd-demo-nav-btn]");
      if (nav && (root.contains(nav) || nav.closest("[data-adhd-demo-modal]"))) {
        goToPage(nav.getAttribute("data-page"));
        return;
      }

      /* Interactive demo controls must win over locked wrappers / upgrade chrome */
      var habitToggle = target.closest("[data-habit-toggle]");
      if (habitToggle && root.contains(habitToggle)) {
        var hid = habitToggle.getAttribute("data-habit-toggle");
        var dayKey = habitToggle.getAttribute("data-day");
        state.habits.forEach(function (habit) {
          if (habit.id === hid) {
            habit.logs = habit.logs || {};
            habit.logs[dayKey] = !habit.logs[dayKey];
          }
        });
        saveDemoState(state);
        renderCurrentPage();
        return;
      }
      if (target.closest("[data-habit-add]") && root.contains(target.closest("[data-habit-add]"))) {
        if (!checkDemoLimit("customHabits", state.habits)) return;
        var habitInput = root.querySelector("[data-habit-new]");
        var habitName = clampText(habitInput && habitInput.value, 80);
        if (!habitName) {
          toast("Type a habit name first, then press Add habit.");
          if (habitInput) habitInput.focus();
          return;
        }
        var habitDays = weekDates(state.settings.weekStartsOn);
        var logs = {};
        habitDays.forEach(function (d) {
          logs[d] = false;
        });
        state.habits.push({ id: uid(), name: habitName, logs: logs, isVisitorCreated: true });
        saveDemoState(state);
        renderCurrentPage();
        return;
      }
      var habitDelete = target.closest("[data-habit-delete]");
      if (habitDelete && root.contains(habitDelete)) {
        event.preventDefault();
        var habitDel = habitDelete.getAttribute("data-habit-delete");
        state.habits = state.habits.filter(function (habit) {
          return habit.id !== habitDel || !!habit.isDemoSample;
        });
        saveDemoState(state);
        renderCurrentPage();
        toast("Habit removed.");
        return;
      }

      if (target.closest("[data-task-add]") && root.contains(target.closest("[data-task-add]"))) {
        if (!checkDemoLimit("customTasks", state.tasks)) return;
        var taskInput = root.querySelector("[data-task-new]");
        var taskTitle = clampText(taskInput && taskInput.value, 120);
        if (!taskTitle) {
          toast("Type a task name first, then press Add task.");
          if (taskInput) taskInput.focus();
          return;
        }
        state.tasks.push({ id: uid(), title: taskTitle, done: false, isVisitorCreated: true });
        saveDemoState(state);
        renderCurrentPage();
        return;
      }
      var taskDeleteEarly = target.closest("[data-task-delete]");
      if (taskDeleteEarly && root.contains(taskDeleteEarly)) {
        event.preventDefault();
        var delIdEarly = taskDeleteEarly.getAttribute("data-task-delete");
        state.tasks = state.tasks.filter(function (task) {
          return task.id !== delIdEarly || !!task.isDemoSample;
        });
        saveDemoState(state);
        renderCurrentPage();
        toast("Task deleted.");
        return;
      }
      var taskFilterEarly = target.closest("[data-task-filter]");
      if (taskFilterEarly) {
        state._taskFilter = taskFilterEarly.getAttribute("data-task-filter");
        renderCurrentPage();
        return;
      }

      if (target.closest("[data-selfcare-add]") && root.contains(target.closest("[data-selfcare-add]"))) {
        if (!checkDemoLimit("customSelfCare", state.selfCare)) return;
        var scInputEarly = root.querySelector("[data-selfcare-new]");
        var scTextEarly = clampText(scInputEarly && scInputEarly.value, 120);
        if (!scTextEarly) {
          toast("Type a self-care action first, then press Add action.");
          if (scInputEarly) scInputEarly.focus();
          return;
        }
        state.selfCare.push({ id: uid(), text: scTextEarly, done: false, isVisitorCreated: true });
        saveDemoState(state);
        renderCurrentPage();
        return;
      }
      var scDeleteEarly = target.closest("[data-selfcare-delete]");
      if (scDeleteEarly && root.contains(scDeleteEarly)) {
        event.preventDefault();
        var scIdEarly = scDeleteEarly.getAttribute("data-selfcare-delete");
        state.selfCare = state.selfCare.filter(function (item) {
          return item.id !== scIdEarly || !!item.isDemoSample;
        });
        saveDemoState(state);
        renderCurrentPage();
        toast("Self-care item removed.");
        return;
      }

      if (target.closest("[data-brain-add]") && root.contains(target.closest("[data-brain-add]"))) {
        if (!checkDemoLimit("customBrainDumps", state.brainDumps)) return;
        var brainInputEarly = root.querySelector("[data-brain-new]");
        var brainTextEarly = clampText(brainInputEarly && brainInputEarly.value, 160);
        if (!brainTextEarly) {
          toast("Type a note first, then press Add.");
          if (brainInputEarly) brainInputEarly.focus();
          return;
        }
        state.brainDumps.push({ id: uid(), text: brainTextEarly, isVisitorCreated: true });
        saveDemoState(state);
        renderCurrentPage();
        return;
      }
      var brainDeleteEarly = target.closest("[data-brain-delete]");
      if (brainDeleteEarly && root.contains(brainDeleteEarly)) {
        event.preventDefault();
        var brainIdEarly = brainDeleteEarly.getAttribute("data-brain-delete");
        state.brainDumps = state.brainDumps.filter(function (item) {
          return item.id !== brainIdEarly || !!item.isDemoSample;
        });
        saveDemoState(state);
        renderCurrentPage();
        toast("Brain dump entry deleted.");
        return;
      }

      if (target.closest("[data-bill-add]") && root.contains(target.closest("[data-bill-add]"))) {
        if (!checkDemoLimit("customBills", state.budget.bills)) return;
        var billNameEarly = clampText(root.querySelector("[data-bill-name]") && root.querySelector("[data-bill-name]").value, 80);
        var billAmountEarly = parseMoney(root.querySelector("[data-bill-amount]") && root.querySelector("[data-bill-amount]").value);
        if (!billNameEarly || !billAmountEarly) {
          toast("Enter a bill name and amount first.");
          return;
        }
        state.budget.bills.push({ id: uid(), name: billNameEarly, amount: billAmountEarly, paid: false, isVisitorCreated: true });
        saveDemoState(state);
        renderCurrentPage();
        return;
      }
      var billDeleteEarly = target.closest("[data-bill-delete]");
      if (billDeleteEarly && root.contains(billDeleteEarly)) {
        event.preventDefault();
        var billIdEarly = billDeleteEarly.getAttribute("data-bill-delete");
        state.budget.bills = state.budget.bills.filter(function (bill) {
          return bill.id !== billIdEarly || !!bill.isDemoSample;
        });
        saveDemoState(state);
        renderCurrentPage();
        toast("Bill removed.");
        return;
      }

      var locked = target.closest("[data-adhd-demo-locked]");
      if (locked && (root.contains(locked) || locked.closest("[data-adhd-demo-modal]"))) {
        openUpgradeModal(locked.getAttribute("data-locked"));
        return;
      }

      if (target.closest("[data-adhd-demo-menu]")) {
        setMenuOpen(!(els.sidebar && els.sidebar.classList.contains("is-open")));
        return;
      }
      if (target.closest("[data-adhd-demo-backdrop]")) {
        setMenuOpen(false);
        return;
      }
      if (target.closest("[data-adhd-demo-calm]")) {
        state.settings.calmMode = !state.settings.calmMode;
        saveDemoState(state);
        applyChrome();
        if (state.settings.calmMode) {
          state.currentPage = "home";
          saveDemoState(state);
          toast("Calm mode on — showing essentials only");
        } else {
          toast("Calm mode off — full dashboard restored");
        }
        renderCurrentPage();
        return;
      }
      if (target.closest("[data-adhd-demo-dark]")) {
        state.settings.darkMode = !state.settings.darkMode;
        saveDemoState(state);
        applyChrome();
        toast(state.settings.darkMode ? "Dark mode on" : "Dark mode off");
        return;
      }
      var paletteBtn = target.closest(".adhd-planner-demo__palette-btn[data-palette]");
      if (paletteBtn && paletteBtn !== root && root.contains(paletteBtn)) {
        state.settings.palette = paletteBtn.getAttribute("data-palette");
        saveDemoState(state);
        applyChrome();
        return;
      }
      if (target.closest("[data-adhd-demo-modal-close]")) {
        closeModal();
        return;
      }
      if (target.closest("[data-adhd-demo-reset-open]")) {
        openModal("reset");
        return;
      }
      if (target.closest("[data-adhd-demo-reset-confirm]")) {
        state = resetDemoState();
        closeModal();
        setMenuOpen(false);
        goToPage("home");
        renderCurrentPage();
        announce("Demo restored to its original sample information.");
        toast("Demo restored to its original sample information.");
        if (config.showWelcomeOverlay === true) {
          openModal("welcome");
        }
        return;
      }
      if (target.closest("[data-adhd-demo-welcome-start]")) {
        dismissWelcome(false);
        return;
      }
      if (target.closest("[data-adhd-demo-welcome-compare]")) {
        showComparison();
        return;
      }

      var billFilter = target.closest("[data-bill-filter]");
      if (billFilter) {
        state._billFilter = billFilter.getAttribute("data-bill-filter");
        renderCurrentPage();
      }
    }

    function onInput(event) {
      var target = eventTarget(event);
      if (!target || !isDemoEventTarget(target)) return;

      if (target.matches("[data-task-toggle]")) {
        applyTaskToggle(target);
        return;
      }
      if (target.matches("[data-selfcare-toggle]")) {
        applySelfCareToggle(target);
        return;
      }
      if (target.matches("[data-bill-toggle]")) {
        var billId = target.getAttribute("data-bill-toggle");
        state.budget.bills.forEach(function (bill) {
          if (bill.id === billId) bill.paid = !!target.checked;
        });
        var billRow = target.closest(".adhd-planner-demo__item");
        if (billRow) billRow.classList.toggle("is-done", !!target.checked);
        saveDemoState(state);
        if (state.currentPage === "home" || state.currentPage === "budget") renderCurrentPage();
        return;
      }

      if (target.matches("[data-today-focus]")) {
        state.today.focus = clampText(target.value, 120);
        saveDemoState(state);
        return;
      }
      if (target.matches("[data-today-priority]")) {
        var idx = Number(target.getAttribute("data-today-priority"));
        state.today.priorities[idx] = clampText(target.value, 120);
        saveDemoState(state);
        return;
      }
      if (target.matches("[data-today-notes]")) {
        state.today.notes = clampText(target.value, 500);
        saveDemoState(state);
        return;
      }
      if (target.matches("[data-daily-brain]")) {
        ensureDailyState(state);
        state.daily.brainDump = clampText(target.value, 500);
        saveDemoState(state);
        return;
      }
      if (target.matches("[data-daily-selfcare]")) {
        ensureDailyState(state);
        state.daily.selfCareNotes = clampText(target.value, 400);
        saveDemoState(state);
        return;
      }
      if (target.matches("[data-daily-task-line]")) {
        ensureDailyState(state);
        var lineIdx = Number(target.getAttribute("data-daily-task-line"));
        if (!isNaN(lineIdx) && lineIdx >= 0 && lineIdx < 4) {
          state.daily.taskLines[lineIdx] = clampText(target.value, 120);
          saveDemoState(state);
        }
        return;
      }
      if (target.matches("[data-task-title]")) {
        var taskId = target.getAttribute("data-task-title");
        state.tasks.forEach(function (task) {
          if (task.id === taskId) task.title = clampText(target.value, 120);
        });
        saveDemoState(state);
        return;
      }
      if (target.matches("[data-brain-text]")) {
        var brainId = target.getAttribute("data-brain-text");
        state.brainDumps.forEach(function (item) {
          if (item.id === brainId) item.text = clampText(target.value, 160);
        });
        saveDemoState(state);
        return;
      }
      if (target.matches("[data-habit-name]")) {
        var habitId = target.getAttribute("data-habit-name");
        state.habits.forEach(function (habit) {
          if (habit.id === habitId && habit.isVisitorCreated) habit.name = clampText(target.value, 80);
        });
        saveDemoState(state);
        return;
      }
      if (target.matches("[data-daily-date]")) {
        if (target.value && target.value !== todayKey()) {
          target.value = todayKey();
          openUpgradeModal("daily-other");
        }
        return;
      }
      if (target.matches("[data-setting-palette]")) {
        state.settings.palette = target.value;
        saveDemoState(state);
        applyChrome();
        return;
      }
      if (target.matches("[data-setting-calm]")) {
        state.settings.calmMode = !!target.checked;
        saveDemoState(state);
        applyChrome();
        if (state.settings.calmMode) {
          state.currentPage = "home";
          saveDemoState(state);
          toast("Calm mode on — showing essentials only");
        } else {
          toast("Calm mode off — full dashboard restored");
        }
        renderCurrentPage();
        return;
      }
      if (target.matches("[data-setting-dark]")) {
        state.settings.darkMode = !!target.checked;
        saveDemoState(state);
        applyChrome();
        toast(state.settings.darkMode ? "Dark mode on" : "Dark mode off");
        return;
      }
      if (target.matches("[data-setting-datefmt]")) {
        state.settings.dateFormat = target.value;
        saveDemoState(state);
        applyChrome();
        return;
      }
      if (target.matches("[data-setting-weekstart]")) {
        state.settings.weekStartsOn = Number(target.value);
        saveDemoState(state);
        if (state.currentPage === "habits") renderCurrentPage();
        else applyChrome();
      }
    }

    function onKeydown(event) {
      if ((event.key === "Enter" || event.key === " ") && event.target instanceof Element) {
        var lockedEl = event.target.closest("[data-adhd-demo-locked]");
        if (lockedEl && root.contains(lockedEl) && event.target === lockedEl) {
          event.preventDefault();
          openUpgradeModal(lockedEl.getAttribute("data-locked"));
          return;
        }
      }
      if (event.key === "Escape") {
        if (activeTourStep >= 0) {
          endTourFlow(false);
          return;
        }
        if (activeModal) {
          closeModal();
          return;
        }
        setMenuOpen(false);
        return;
      }
      if (!activeModal || event.key !== "Tab") return;
      var focusables = getFocusable(activeModal);
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    document.addEventListener("click", onPurchaseClick, { signal: signal });
    bindModalActions();
    document.addEventListener("click", onClick, { signal: signal });
    root.addEventListener("input", onInput, { signal: signal });
    root.addEventListener("change", onInput, { signal: signal });
    document.addEventListener("keydown", onKeydown, { signal: signal });
    function signalDemoReady() {
      try {
        if (window.parent && window.parent !== window) {
          window.parent.postMessage({ type: "ss-demo-ready" }, "*");
        }
      } catch (err) {}
    }

    window.addEventListener(
      "message",
      function (event) {
        if (!event || !event.data || event.data.type !== "ss-demo-restart-tour") return;
        window.requestAnimationFrame(function () {
          startTourFlow(0);
        });
      },
      { signal: signal }
    );

    root._adhdDemoCleanup = function () {
      closeModal(true);
      if (ctaResizeObserver) ctaResizeObserver.disconnect();
      abortController.abort();
      root.dataset.demoInitialized = "false";
    };

    renderCurrentPage();

    var showWelcome = config.showWelcomeOverlay === true && !embedMode;
    if (showWelcome && !state.welcomeDismissed) {
      openModal("welcome");
      signalDemoReady();
    } else if (embedParams.get("tour") === "1") {
      window.requestAnimationFrame(function () {
        startTourFlow(0);
        signalDemoReady();
      });
    } else {
      signalDemoReady();
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll("[data-adhd-demo-root]").forEach(initDemo);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    var root = event.target.querySelector("[data-adhd-demo-root]");
    if (root && typeof root._adhdDemoCleanup === "function") root._adhdDemoCleanup();
  });
})();
